import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CommentSectionChatMessage from './CommentSectionChatMessage'
import '../components/css/CommentSection.css'

class CommenSection extends Component {

    render(){
        var messageArr = []
        for (var key in this.props.messages) {
            if(this.props.messages.hasOwnProperty(key))
                messageArr.push(this.props.messages[key])
        }

        return (
            <div>
                {messageArr.length === 0 &&
                    <div className='firstMessage'><h4>Be the ﬁrst to say something brilliant about this idea!</h4></div>
                }
                {messageArr.map((msg) =>
                   <CommentSectionChatMessage className='CommentSectionChatMessage'
                       fromName={msg.fromName}
                       fromPhotoURL={msg.fromPhotoURL}
                       message={msg.text}
                       timestamp={msg.timestamp}
                       key={msg.timestamp} />,
               )}
            </div>
        )
    }
}
CommenSection.propTypes = {
    messages: PropTypes.object,
    userName: PropTypes.string.isRequired,
}

export default CommenSection



// WEBPACK FOOTER //
// ./src/components/CommentSection.js